// extracted by mini-css-extract-plugin
export default {"tagWrapper":"MaintainedDevicesView_tagWrapper__++a6X","headerDescriptionsRow":"MaintainedDevicesView_headerDescriptionsRow__ga8X3"};